import { render, staticRenderFns } from "./AgregarListaProductos.vue?vue&type=template&id=08b87b08"
import script from "./AgregarListaProductos.vue?vue&type=script&lang=js"
export * from "./AgregarListaProductos.vue?vue&type=script&lang=js"
import style0 from "./AgregarListaProductos.vue?vue&type=style&index=0&id=08b87b08&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports